import { render, staticRenderFns } from "./BandForm.vue?vue&type=template&id=335260a4&"
import script from "./BandForm.vue?vue&type=script&lang=js&"
export * from "./BandForm.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/vue-quill-editor/typography.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/vendor/libs/vue-quill-editor/editor.scss?vue&type=style&index=1&lang=scss&"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335260a4')) {
      api.createRecord('335260a4', component.options)
    } else {
      api.reload('335260a4', component.options)
    }
    module.hot.accept("./BandForm.vue?vue&type=template&id=335260a4&", function () {
      api.rerender('335260a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/bands/BandForm.vue"
export default component.exports